import { Progress } from '@mantine/core'

// ─────────────────────────────────────────────
// 型定義
// ─────────────────────────────────────────────
export type ProgressBarProps = {
  /** 進捗率（0〜100）。小数点以下も受け付け、0未満は0、100超は100にクランプ */
  rate: number
  className?: string
}

// ─────────────────────────────────────────────
// コンポーネント
// ─────────────────────────────────────────────
/**
 * Figma デザインに基づくプログレスバー。
 * background: #CBCBCE / fill: #FFC500 / height: 16px / radius: 32px
 *
 * @example
 * <ProgressBar rate={60} />
 */
export const ProgressBar = ({ rate, className }: ProgressBarProps) => {
  const clamped = Math.min(100, Math.max(0, rate))

  return (
    <Progress
      value={clamped}
      color="primary"
      size={16}
      radius={32}
      className={className}
      styles={{ root: { backgroundColor: '#CBCBCE' } }}
      role="progressbar"
      aria-valuenow={clamped}
      aria-valuemin={0}
      aria-valuemax={100}
    />
  )
}
